export default {"src":"/_next/static/media/rice.16fa42f0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};